import React, { useCallback } from 'react';
import { SmlsHeaderPlaceholder, SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useTranslation, Trans } from 'react-i18next';

import { DefaultMsgPageProps } from './types';

const DefaultMsgPage = ({
  traductionKey = '',
  image,
  traductionContentParams,
  isPrimaryLoading = false,
  onPrimary,
  onSecondary,
  children,
  redirectUrl,
}: DefaultMsgPageProps) => {
  const { t } = useTranslation(traductionKey);

  const renderButton = useCallback(() => {
    if (!onPrimary && !onSecondary) return null;

    return (
      <div className="smls-components-message-container-buttons">
        {onPrimary && (
          <SmlsButton
            text={t('btn_primary')}
            onClick={onPrimary}
            isLoading={isPrimaryLoading}
            animation={isPrimaryLoading}
          />
        )}
        {onSecondary && <SmlsButton text={t('btn_secondary')} onClick={onSecondary} color="hyperlink" />}
      </div>
    );
  }, [onPrimary, onSecondary, t, traductionKey, isPrimaryLoading]);

  const renderSub = useCallback(() => {
    const traduction = t('content_sub');
    if (traduction === 'content_sub') {
      return null;
    }

    return <p>{traduction}</p>;
  }, [t, traductionKey]);

  const getClassIcon = useCallback(() => {
    switch (image) {
      case 'beachChair':
        return 'smls-icon-beach_chair';
      case 'brokenSuitcase':
        return 'smls-icon-broken_suitcase';
      case 'cellPhone':
        return 'smls-icon-cell_phone';
      case 'email':
        return 'smls-icon-email';
      case 'profile':
        return 'smls-icon-profile';
      default:
        return '';
    }
  }, [image]);

  return (
    <div className="smls-components-message">
      <SmlsHeaderPlaceholder redirectUrl={redirectUrl !== undefined ? redirectUrl : window.location.origin} />
      <div className="smls-components-message-container">
        <div>
          <div className={`image ${getClassIcon()}`} />
          <div className="smls-components-message-container-content">
            <h3>{t('header')}</h3>
            <p>
              <Trans t={t} i18nKey="content" values={traductionContentParams} components={{ bold: <b /> }} />
            </p>
            {renderSub()}
            {renderButton()}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DefaultMsgPage;
